<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Collection Notice
      </h3>

      <p class="text-sm leading-6 text-gray-500">Below is the collection schedule for your order.</p>

      <div class="flex flex-col mt-2">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
            <table class="min-w-full">
              <thead>
                <tr>
                  <th class="px-4 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">
                    Collection Date
                  </th>
                  <th class="px-4 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">
                    Warehouse
                  </th>
                  <th class="px-4 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">
                    Location
                  </th>
                  <th class="px-4 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">
                    Items Pending
                  </th>
                  <th colspan="2" class="px-4 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase">
                    Collected
                  </th>

                </tr>
              </thead>
              <tbody v-for="date in dates">
                <template v-for="(item, index) in collectionData[date]">
                  <tr v-if="index === 0" class="bg-white">
                    <td :rowspan="Object.values(collectionData[date]).length" class="px-4 py-2 whitespace-nowrap border-b border-r border-gray-200 text-sm leading-5 font-medium text-gray-900">
                      {{ date }}
                    </td>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.warehouse.name }}
                      <p><small>{{ item.warehouse.address }}</small></p>
                    </td>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.warehouse.location }}
                    </td>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.pending }}
                    </td>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.completed }}
                    </td>
                    <td class="px-2 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      <span v-if="item.pending == '0'"><icon class="inline w-4 h-4 text-green-600" name="tick"></icon></span>
                    </td>
                  </tr>
                  <tr v-else>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.warehouse.name }}
                      <p><small>{{ item.warehouse.address }}</small></p>
                    </td>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.warehouse.location }}
                    </td>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.pending }}
                    </td>
                    <td class="px-4 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {{ item.completed }}
                    </td>
                    <td class="px-2 py-2 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      <span title="completed" v-if="item.pending == '0'"><icon class="inline w-4 h-4 text-green-600" name="tick"></icon></span>
                    </td>
                  </tr>
                </template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Icon from '@/Shared/Icon'
export default {
  name: 'CollectionNotice',
  components: {Icon},
  props: {
    collectionData: {},
  },

  computed: {
    dates() {
      return Object.keys(this.collectionData)
    }
  }
}
</script>
